// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfilePublication_profile-publication__CQOKP {
  margin-bottom: 25px;
  background: white;
  border-radius: 5px;
  padding: 15px 20px;
}
.ProfilePublication_profile-publication__CQOKP .ProfilePublication_coauthors__gonks {
  margin-bottom: 3px;
  color: var(--dark-grey);
}
.ProfilePublication_profile-publication__CQOKP .ProfilePublication_coauthors__gonks span {
  margin-right: 10px !important;
  font-style: italic;
}
.ProfilePublication_profile-publication__CQOKP .ProfilePublication_title__kIXw1 {
  margin-bottom: 3px;
}
.ProfilePublication_profile-publication__CQOKP .ProfilePublication_title__kIXw1 .ProfilePublication_paper-title__rS2Ts {
  font-weight: bold;
  cursor: pointer;
}
.ProfilePublication_profile-publication__CQOKP .ProfilePublication_title__kIXw1 .ProfilePublication_paper-title__rS2Ts:hover {
  text-decoration: underline;
  color: var(--blue);
}
.ProfilePublication_profile-publication__CQOKP .ProfilePublication_title__kIXw1 .ProfilePublication_venue__lm1jD {
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Components/ProfilePublication/ProfilePublication.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AACF;AAAE;EACE,kBAAA;EACA,uBAAA;AAEJ;AADI;EACE,6BAAA;EACA,kBAAA;AAGN;AAAE;EACE,kBAAA;AAEJ;AADI;EACE,iBAAA;EACA,eAAA;AAGN;AADI;EACE,0BAAA;EACA,kBAAA;AAGN;AADI;EACE,kBAAA;AAGN","sourcesContent":[".profile-publication {\n  margin-bottom: 25px;\n  background: white;\n  border-radius: 5px;\n  padding: 15px 20px;\n  .coauthors {\n    margin-bottom: 3px;\n    color: var(--dark-grey);\n    span {\n      margin-right: 10px !important;\n      font-style: italic;\n    }\n  }\n  .title {\n    margin-bottom: 3px;\n    .paper-title {\n      font-weight: bold;\n      cursor: pointer;\n    }\n    .paper-title:hover {\n      text-decoration: underline;\n      color: var(--blue);\n    }\n    .venue {\n      font-style: italic;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profile-publication": `ProfilePublication_profile-publication__CQOKP`,
	"coauthors": `ProfilePublication_coauthors__gonks`,
	"title": `ProfilePublication_title__kIXw1`,
	"paper-title": `ProfilePublication_paper-title__rS2Ts`,
	"venue": `ProfilePublication_venue__lm1jD`
};
export default ___CSS_LOADER_EXPORT___;
